<template>
  <layout>
    <page-header :actions="actions" :header="$t('account.billing')" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps" />
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import Api from './Api'

const resourceBase = 'billing-info'

export default {
  name: 'BillingInfo',

  components: {
    AdminTable,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new Api()
        },
        sortBy: 'name',
        sortDesc: true,
        perPage: 9,
        columns: [
          {
            key: 'name',
            label: this.$t('attributes.billing_name.label'),
            sortable: true,
          },
          {
            key: 'company_name',
            label: this.$t('attributes.billing_company.label'),
            sortable: true,
          },
          {
            key: 'country',
            label: this.$t('attributes.billing_country.label'),
          },
          {
            key: 'is_default',
            label: this.$t('general.default'),
            component: 'value-boolean',
          },
          {
            key: 'created_at',
            label: this.$t('attributes.created_at.label'),
            sortable: true,
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
        ],

        // override search fields here using fields schema
        searchFields: [
          {
            component: 'text-field',
            type: 'search',
            attribute: 'query',
            placeholder: this.$t('general.search'),
          },
        ],

        // define custom row actions
        // eslint-disable-next-line no-unused-vars
        rowActions: item => {
          let actions = ['edit']

          if (item.is_default === false) {
            actions.push({
              label: this.$t('general.default'),
              variant: 'light',
              handler: async () => {
                try {
                  await new Api().makeDefault(item.id)
                  this.$refs.table.refresh()
                } catch (err) {
                  this.$toast.error(err.message)
                }
              },
            })
          }
          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },
      },
    }
  },

  computed: {
    // Page header actions
    actions() {
      return [
        {
          id: 'create',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.$router.push({
              name: `${resourceBase}.create`,
            })
          },
        },
      ]
    },
  },
}
</script>
